/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_Show_MoreInputs */

const cs_pm_show_more = /** @type {(inputs: Pm_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zobrazit další (${i?.n})`)
};

const en_pm_show_more = /** @type {(inputs: Pm_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show more (${i?.n})`)
};

/**
* | output |
* | --- |
* | "Show more ({n})" |
*
* @param {Pm_Show_MoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_show_more = /** @type {((inputs: Pm_Show_MoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Show_MoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_show_more(inputs)
	return cs_pm_show_more(inputs)
});